import React, { ReactNode } from 'react';
import { isAfter, startOfDay } from 'date-fns';
import { twMerge } from '@shared/utils/twMerge';
import { DatePicker } from './DatePicker';
import './DateRangePicker.scss';

const { RangePicker } = DatePicker;

export type DateRangeType = [Date | null, Date | null];

type AntRangePickerProps = React.ComponentProps<typeof RangePicker>;

export type DateRangePickerProps = Omit<AntRangePickerProps, 'value' | 'onChange'> & {
  value: DateRangeType;
  onChange: (value: DateRangeType) => void;
  prefixIcon?: ReactNode;
  wrapperClassName?: string;
};

const defaultDisabledDate = (current: Date | null) =>
  current ? isAfter(startOfDay(current), startOfDay(new Date())) : false;

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onChange,
  prefixIcon,
  wrapperClassName,
  disabledDate = defaultDisabledDate,
  separator = '-',
  ...rest
}) => {
  const handleChange: AntRangePickerProps['onChange'] = dates => {
    onChange((dates as DateRangeType) ?? [null, null]);
  };

  const picker = (
    <RangePicker
      {...rest}
      value={value}
      onChange={handleChange}
      disabledDate={disabledDate}
      separator={separator}
    />
  );

  if (!prefixIcon) {
    return picker;
  }

  return (
    <div className={twMerge('relative', wrapperClassName)}>
      <span className="absolute left-[12px] top-1/2 z-[1] -translate-y-1/2">{prefixIcon}</span>
      {picker}
    </div>
  );
};
